import React from 'react';
import moment from 'moment';


class FullReport extends React.Component {
    renderUser = (fullReport) => {
        if (!fullReport.users || !fullReport.users.length) {
            return null;
        }

        const users = fullReport.users;
        return users.map(this.renderUserRow);
    };

    renderUserRow = (user) => {
        return (
            <div className='user' key={user.id}>
                <div className='col col-6 name'>{user.name}</div>
                <div className='col col-6 col-right'>
                    <div className='right'>
                        NI: {user.ni}<br/>
                        BANK: {user.bank}<br/>
                        IBAN: {user.iban}
                    </div>
                </div>
                <div>
                    {this.renderMethods(user)}
                </div>
            </div>
        );
    };

    renderMethods = (user) => {
        return (
            <div>
                <div className='table-responsive'>
                    <table className='shift-table'>
                        <thead>
                            <tr>
                                <th>DATE</th>
                                <th>POSITION</th>
                                <th>STATUS</th>
                                <th>HOURS</th>
                                <th>HOURLY RATE</th>
                                <th>COST</th>
                                <th>METHOD</th>
                            </tr>
                        </thead>
                        <tbody>
                            {user.shifts.map(this.renderShift)}
                        </tbody>
                    </table>
                </div>
                <div className='text-right table-responsive'>
                    <table className='user-total-table'>
                        <thead>
                            <tr>
                                <th></th>
                                {user.methods.map(m => <th>{m.payment}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>TOTAL:</strong></td>
                                {user.methods.map(m => <td>{m.total_cost.toFixed(2)}{m.currency}</td>)}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    renderShift = (shift) => {
        return (
            <tr>
                <td>{shift.date}</td>
                <td>{shift.position}</td>
                <td>{shift.candidate.status || "ok"}</td>
                <td>{shift.candidate.hours.toFixed(2)}</td>
                <td>{shift.candidate.hourly_rate.toFixed(2)}{shift.currency}</td>
                <td>{shift.candidate.cost.toFixed(2)}{shift.currency}</td>
                <td>{shift.payment}</td>
            </tr>
        );
    };

    renderTotal = (fullReport) => {
        if (!fullReport.total || !fullReport.total.length) {
            return null;
        }

        const totalRow = (method) => (
            <tr key={`${method.payment}${method.currency}`}>
                <td>{(method.total_cost).toFixed(2)}{method.currency}</td>
                <td>{method.our_fee}{method.currency}</td>
                <td>{method.payment}</td>
            </tr>
        );

        return (
            <div className='table-responsive'>
                <table className='total-table'>
                    <tr>
                        <th>TOTAL COST</th>
                        <th>OUR FEE</th>
                        <th>METHOD</th>
                    </tr>
                    {fullReport.total.map(totalRow)}
                </table>
            </div>
        );
    };

    render() {
        const fullReport = this.props.fullReport;

        if (!fullReport || !fullReport.total.length) {
            return (
                <div className='full-report'>
                    <h1>Monthly report - {this.props.date.format("MMMM, YYYY")}</h1>
                    <div>No finished shifts found</div>
                </div>
            );
        }

        const start_time = this.props.date.startOf('month');
        const end_time = moment(start_time).add(1, 'months');
        const queryString = `?start_time=${start_time.format("YYYY-MM-DD HH:mm")}&end_time=${end_time.format("YYYY-MM-DD HH:mm")}`;
        const pdfUrl = `${DJ_CONST.API_BASE}${DJ_CONST.API.shiftFullReportPdf}${queryString}`;
        return (
            <div className='full-report'>
                <div className='clearfix'>
                    <h1 className='left'>Monthly report - {this.props.date.format("MMMM, YYYY")}</h1>
                    <a className='btn-download right' href={pdfUrl} target='_blank'>
                        Download report
                    </a>
                </div>
                {this.renderTotal(fullReport)}
                {this.renderUser(fullReport)}
            </div>
        );
    }
}


export default FullReport;



/** WEBPACK FOOTER **
 ** ./app/src/components/FullReport.js
 **/